import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const brandValues = [
  {
    icon: 'ri-shield-check-line',
    title: '品质保证',
    description: '所有漫画均经过精心筛选，确保画质清晰、翻译准确，为你提供最佳阅读体验。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    description: '与韩国同步更新，第一时间为你带来最新章节，绝不让你错过任何精彩剧情。',
  },
  {
    icon: 'ri-device-line',
    title: '多端适配',
    description: '完美适配电脑、平板和手机，随时随地享受流畅的下拉式阅读体验。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '用户至上',
    description: '认真倾听每一位用户的反馈，持续优化产品体验，做你最贴心的漫画阅读伙伴。',
  },
  {
    icon: 'ri-lock-line',
    title: '安全可靠',
    description: '严格遵守隐私保护法规，保障你的个人信息和阅读记录安全无虞。',
  },
];

const faqs = [
  {
    question: '韩漫漫画网站是否完全免费？',
    answer: '是的！韩漫漫画网站所有漫画内容均完全免费提供。我们致力于为韩漫爱好者打造一个无障碍的阅读平台，无需注册即可开始阅读，没有任何隐藏收费项目。',
  },
  {
    question: '什么是下拉式阅读模式？',
    answer: '下拉式阅读是一种专为移动端优化的漫画阅读方式。区别于传统的翻页模式，下拉式阅读让你只需向下滑动屏幕即可连续阅读，更加流畅自然，完美适配手机和平板设备。',
  },
  {
    question: '网站上的韩漫是否有删减？',
    answer: '我们提供的所有韩漫均为无删减版本，完整呈现作者原意。我们尊重每一位创作者的劳动成果，绝不擅自修改漫画内容，确保你看到的是最原汁原味的韩漫作品。',
  },
  {
    question: '更新频率是怎样的？',
    answer: '我们与韩国漫画平台保持同步更新，热门漫画通常每周更新1-2话。遇到节假日或作者休刊时会略有延迟，我们会及时在网站上公告说明。',
  },
  {
    question: '如何在手机上获得更好的阅读体验？',
    answer: '直接在手机浏览器中打开我们的网站即可享受优化后的移动端体验。下拉式阅读模式在手机上表现尤为出色，你也可以将网站添加到手机主屏幕，像使用 App 一样方便快捷。',
  },
];

export default function AboutPage() {
  return (
    <main className="min-h-screen bg-background-50">
      {/* JSON-LD: AboutPage + BreadcrumbList + FAQPage */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "AboutPage",
        "name": "关于我们 - 韩漫漫画",
        "url": "https://www.example.com/about",
        "description": "韩漫漫画致力于为华语地区的韩漫爱好者提供最优质的免费在线阅读服务",
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "首页",
              "item": "https://www.example.com/"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "关于我们",
              "item": "https://www.example.com/about"
            }
          ]
        }
      })}} />
      {/* JSON-LD: FAQPage */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "韩漫漫画网站是否完全免费？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "是的！韩漫漫画网站所有漫画内容均完全免费提供。我们致力于为韩漫爱好者打造一个无障碍的阅读平台，无需注册即可开始阅读，没有任何隐藏收费项目。"
            }
          },
          {
            "@type": "Question",
            "name": "什么是下拉式阅读模式？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "下拉式阅读是一种专为移动端优化的漫画阅读方式。区别于传统的翻页模式，下拉式阅读让你只需向下滑动屏幕即可连续阅读，更加流畅自然，完美适配手机和平板设备。"
            }
          },
          {
            "@type": "Question",
            "name": "网站上的韩漫是否有删减？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "我们提供的所有韩漫均为无删减版本，完整呈现作者原意。我们尊重每一位创作者的劳动成果，绝不擅自修改漫画内容，确保你看到的是最原汁原味的韩漫作品。"
            }
          }
        ]
      })}} />
      <div className="bg-foreground-900">
        <Navbar />
        <div className="pt-20 pb-16 px-4 md:px-6 text-center">
          <nav className="flex items-center justify-center gap-2 text-xs text-foreground-300 mb-6">
            <Link to="/" className="hover:text-white transition-colors whitespace-nowrap">首页</Link>
            <span>/</span>
            <span className="text-white whitespace-nowrap">关于我们</span>
          </nav>
          <p className="text-foreground-400 text-xs uppercase tracking-widest mb-3">
            关于我们
          </p>
          <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4">
            韩漫漫画
          </h1>
          <p className="text-foreground-300 text-sm max-w-xl mx-auto mb-8">
            致力于为华语地区的韩漫爱好者提供最优质的免费在线阅读服务
          </p>

          <div className="flex items-center justify-center gap-4">
            <Link
              to="/category/all"
              className="whitespace-nowrap px-6 py-3 rounded-full bg-white text-foreground-900 font-medium text-sm hover:bg-background-100 transition-all cursor-pointer"
            >
              浏览漫画
            </Link>
            <a
              href="#contact"
              className="whitespace-nowrap px-6 py-3 rounded-full border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-all cursor-pointer"
            >
              联系我们
            </a>
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 md:px-6 pb-16">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
            {brandValues.map((value) => (
              <div
                key={value.title}
                className="bg-foreground-800/50 rounded-xl p-4 text-left hover:bg-foreground-800 transition-colors"
              >
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500/20 text-primary-300 mb-3">
                  <i className={`${value.icon} text-sm`}></i>
                </div>
                <h4 className="text-white text-sm font-medium mb-1">{value.title}</h4>
                <p className="text-foreground-400 text-[11px] leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <section className="py-16 md:py-20 px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              品牌声誉
            </h2>
            <p className="text-foreground-500 text-sm max-w-lg mx-auto">
              来自广大韩漫爱好者的真实认可
            </p>
          </div>

          <div className="bg-background-100 rounded-2xl p-8 md:p-12">
            <div className="flex items-center gap-4 mb-8">
              <div className="px-5 py-2.5 rounded-full bg-foreground-900 text-white text-lg font-bold flex items-center gap-2 whitespace-nowrap">
                <i className="ri-star-fill text-accent-400"></i>
                9.6
              </div>
              <div>
                <p className="text-sm font-medium text-foreground-900">用户综合评分</p>
                <p className="text-xs text-foreground-400">基于 12,580+ 条真实评价</p>
              </div>
            </div>

            <blockquote className="text-base md:text-lg text-foreground-700 leading-relaxed italic mb-6 border-l-3 border-primary-400 pl-6">
              我们相信，每一个人都值得拥有触手可及的好故事。韩漫漫画不仅是一个阅读平台，更是一个连接创作者与读者的温暖社区。我们用心甄选每一部作品，确保每一位读者都能在这里找到属于自己的那份感动。
            </blockquote>

            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                <i className="ri-heart-line text-primary-500"></i>
              </div>
              <div>
                <p className="text-sm font-medium text-foreground-900">韩漫漫画团队</p>
                <p className="text-xs text-foreground-400">contact@example.com</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="contact" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              联系我们
            </h2>
            <p className="text-foreground-500 text-sm max-w-lg mx-auto">
              有任何问题或建议？我们非常乐意听取你的声音
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            <div className="bg-background-50 rounded-xl p-6 text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <h4 className="font-medium text-foreground-900 text-sm mb-1">电子邮箱</h4>
              <p className="text-xs text-foreground-500">contact@example.com</p>
            </div>
            <div className="bg-background-50 rounded-xl p-6 text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                <i className="ri-wechat-line text-lg"></i>
              </div>
              <h4 className="font-medium text-foreground-900 text-sm mb-1">微信公众号</h4>
              <p className="text-xs text-foreground-500">韩漫漫画</p>
            </div>
            <div className="bg-background-50 rounded-xl p-6 text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                <i className="ri-question-answer-line text-lg"></i>
              </div>
              <h4 className="font-medium text-foreground-900 text-sm mb-1">在线客服</h4>
              <p className="text-xs text-foreground-500">工作日 9:00 - 18:00</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              常见问题
            </h2>
            <p className="text-foreground-500 text-sm">
              你可能关心的一些问题
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <details key={index} className="group bg-background-50 rounded-xl border border-background-200/70">
                <summary className="flex items-center justify-between px-6 py-4 cursor-pointer text-sm font-medium text-foreground-900 list-none">
                  {faq.question}
                  <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                </summary>
                <div className="px-6 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}